/*
 * @Author: haoliang.yan
 * @Date: 2017-03-03 16:57:32
 * @Last Modified by: kewei.wang
 * @Last Modified time: 2018-08-14 15:58:35
 */

require('whatwg-fetch');
const fetchJsonp = require('fetch-jsonp');
const assign = require('object-assign');
const host = location.hostname;
const port = location.port;
const protocol = location.protocol;
const parseLink = url => {
    const a = document.createElement('a');
    const ret = {};

    a.href = url;
    ['href', 'search', 'pathname', 'hostname', 'port', 'protocol'].map(key => {
        ret[key] = a[key];
    });

    return ret;
};

const sameDomain = url => {
    const realLink = parseLink(url);

    return host === realLink.hostname && port === realLink.port && protocol === realLink.protocol;
};

const request = (url, params={}) => {
    if(sameDomain(url)) {
        const {method='GET'} = params;

        if(method.toUpperCase() === 'POST') {
            return post(url, params);
        } else {
            return get(url, params);
        }
    } else {
        return fetchJsonp(url, params);
    }
};

const get = (url, params={}) => {
    const defaultParam = {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json,*/*'
            // 'Content-Type': 'application/json'
        }};
    return fetch(url, assign(defaultParam, params));
};

const post = (url, params={}) => {
    const defaultParam = {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Accept': 'application/json,*/*',
            'Content-Type': 'application/json'
        }};
    return fetch(url, assign(defaultParam, params));
};

const json = resp => resp.json();

const addParams = (url, obj)=> {
    let params = [];
    if (url.indexOf('?') === -1) {
        url += '?';
    } else {
        url += '&';
    }
    for (let name in obj) {
        if (obj.hasOwnProperty(name)) {
            params.push(encodeURIComponent(name) + '=' + encodeURIComponent(obj[name]));
        }
    }
    if (params.length > 0) {
        url += params.join('&');
    }
    return url;
};
export {
    get,
    post,
    request,
    json,
    addParams
};
